import { Stack, TextField } from "@mui/material";
import React, { useMemo } from "react";
import { createColumnHelper } from "@tanstack/react-table";
import {
  DeleteModal,
  InputControl,
  ServerPaginatedtable,
  SimpleMenu,
} from "../../../shared";
import { useTipsAndTricks } from "../../Tips&Tricks/hooks/useTipsAndTricks";
import { useNavigate } from "react-router-dom";

export const TipsAndTricksDetails = ({ recipeId }) => {
  const {
    setPagination,
    pagination,
    sorting,
    setSorting,
    listQuery,
    tipsAndTricks,
    onSearchHandler,
    onClearSearch,
    moduleName,
    selectTypeOptions,
    onChangeStatusHandler,
    onDelete,
    isEditable,
    isDeletable,
    deleteInfo,
    resetDeleteInfo,
    confirmDelete,
  } = useTipsAndTricks({
    isList: true,
    recipeId,
    isRecipeTipsList: false,
  });
  const navigate = useNavigate();

  const columnHelper = createColumnHelper([]);

  const columns = useMemo(
    () => [
      columnHelper.accessor("name", {
        header: "Name",
      }),
      columnHelper.accessor("type", {
        header: "Type",
      }),
      columnHelper.display({
        id: "actions",
        cell: (props) => {
          return (
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="flex-end"
              gap="8px"
            >
              <SimpleMenu
                row={props.row}
                editAction={(e) => navigate(`/tips-tricks/edit/${e.id}`)}
                handleDeleteModal={(e) => onDelete(e.id)}
                isDeletable={isDeletable}
                isEditable={isEditable}
              />

              <img alt="details" src="/icons/arrow_forward.png" />
            </Stack>
          );
        },
      }),
    ],
    [],
  );

  return (
    <>
      <ServerPaginatedtable
        defaultData={listQuery?.data?.tipsandtricks ?? []}
        columns={columns}
        onSearchChange={onSearchHandler}
        search={tipsAndTricks?.search}
        onClearSearch={onClearSearch}
        sorting={sorting}
        setSorting={(callback) =>
          setSorting({ tableName: moduleName, callback })
        }
        pagination={pagination}
        paginationProps={
          listQuery.data?.pagination || { total: 0, lastPage: 1 }
        }
        onRowLink={(e) => {
          return `/tips-tricks/details/${e.id}?basic-details`;
        }}
        setPagination={(callback) =>
          setPagination({ tableName: moduleName, callback })
        }
        headerText="Recipe Tips & Procedures"
        isLoading={listQuery?.isLoading}
        tableHeaderContent={
          <Stack
            sx={{
              flexDirection: "row",
              gap: "6px",
              width: "100%",
            }}
          >
            <InputControl
              type="dropdown"
              variant="filter"
              size="small"
              options={selectTypeOptions}
              getOptionLabel={(option) => option?.label || ""}
              isOptionEqualToValue={(option, value) =>
                option.value === value.value
              }
              sx={{
                width: "180px",
              }}
              value={
                (selectTypeOptions &&
                  tipsAndTricks?.filters?.type?.value &&
                  selectTypeOptions?.find(
                    (status) =>
                      status?.value === tipsAndTricks?.filters?.type?.value,
                  )) ||
                null
              }
              onChange={(event, option) => onChangeStatusHandler(option)}
              renderInput={(params) => (
                <TextField {...params} placeholder="Type" />
              )}
            />
          </Stack>
        }
        headerStyle={{
          px: 0,
          fontSize: "18px",
          fontWeight: 500,
          height: "56px",
          py: "12px",
          borderBottom: "1px solid #E0E0E0",
        }}
        headerContentStyle={{ px: 0 }}
        enableTableContainerPaddingBottom
      />
      <DeleteModal
        open={deleteInfo.show}
        handleClose={() => resetDeleteInfo()}
        onConfirm={() => confirmDelete()}
      />
    </>
  );
};
